"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const viewport = {
  small: '425px',
  medium: '768px',
  large: '992px',
  xlarge: '1200px',
  xxlarge: '1400px'
};
var _default = exports.default = {
  sm: "(min-width: ".concat(viewport.small, ")"),
  md: "(min-width: ".concat(viewport.medium, ")"),
  lg: "(min-width: ".concat(viewport.large, ")"),
  xl: "(min-width: ".concat(viewport.xlarge, ")"),
  xxl: "(min-width: ".concat(viewport.xxlarge, ")")
};